import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { MediumType, SessionService} from '@ridango/components';
import { AuthService} from '@ridango/core';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TravelCardInput } from '../purchase-medium.model';
@Component({
    selector: 'rwidget-email-input',
    templateUrl: './email-input.component.html',
    styleUrls: ['./email-input.component.scss']
})
export class EmailInputComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    @Input() required = false;
    @Input() reset: Observable<boolean>;
    @Input() disabled: Observable<boolean>;

    @Output() onChange = new EventEmitter<TravelCardInput>();

    emailForm: FormGroup;
    emailCustomer;
    loginStatus;

    constructor(
        public session: SessionService,
        private auth: AuthService,
        ) {}

    ngOnInit() {
        this.reset.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => this.emailForm.reset());
        this.disabled.pipe(takeUntil(this.componentDestroyed$)).subscribe((isDisabled) => {
            if (isDisabled) {
                this.emailForm.disable();
            } else {
                this.emailForm.enable();
            }
        });

        const defaultEmail = this.auth.getLoginStatus() ? this.session.getLoggedInEmail() : '';

        this.emailForm = new FormGroup({
            email: new FormControl(defaultEmail, [Validators.required, Validators.email])
        });

        if (this.emailForm.controls['email'].value) {
            this.change();
        }
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }


    change() {
        this.onChange.emit({
            type: MediumType.Email,
            value: this.emailForm.controls['email'].value,
            isValid: this.emailForm.valid,
        });
    }
}
